
import { FloatingFeature } from "@models";
import { 
  Resource, 
  UpgradableNumber 
} from "@dndModels";
import { SpellLevel } from "@dndModels/Types";

/**
 * This is a generic term for Spell Slots, Ki Points, Sorcery Points,
 * Lay on Hands, Healing Light, etc.  
 * It also could work for Material Spell Components, but I don't 
 * want to worry about that right now.
 * level is for spell slots (and pact slots), 
 * and it's what level the slot is.
 * total is the total number of that resource they have.
 */
export class ResourceFeature extends FloatingFeature {
  type_id = "";
  slots = false;
  slot_level: SpellLevel = 1;
  slot_name = "";
  total: UpgradableNumber = new UpgradableNumber();
  size: UpgradableNumber = new UpgradableNumber();
  // If this is true then this 
  // gets added to others of the same type
  // instead of replacing it
  stacks = false; 
  resource: Resource | undefined = undefined;
  refresh_rule = "Inherit";
  refresh_x_on_short: UpgradableNumber = new UpgradableNumber(-1);
  default_dice_size = 1;
  override_name = "";
  override_singular = "";

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.type_id = obj.type_id ? obj.type_id : null;
      if (obj.total) {
        if (obj.total.base !== undefined) {
          this.total = new UpgradableNumber(obj.total);
        } else {
          this.total.base = obj.total;
        }
      }
      if (obj.size) {
        if (obj.size.base !== undefined) {
          this.size = new UpgradableNumber(obj.size);
        } else {
          this.size.base = obj.size;
        }
      } else {
        this.size.base = 1;
      }
      this.stacks = obj.stacks ? obj.stacks : false;
      
      this.slots = obj.slots ? obj.slots : false;
      this.slot_level = obj.slot_level ? obj.slot_level : 1;
      this.slot_name = obj.slot_name ? obj.slot_name : "";
      this.refresh_rule = obj.refresh_rule ? obj.refresh_rule : "Inherit";
      this.refresh_x_on_short = obj.refresh_x_on_short ? new UpgradableNumber(obj.refresh_x_on_short) : new UpgradableNumber(-1);
      this.override_name = obj.override_name ? obj.override_name : "";
      this.override_singular = obj.override_singular ? obj.override_singular : "";
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.type_id = obj.type_id ? obj.type_id : null;
  //     if (obj.total) {
  //       if (obj.total.base !== undefined) {
  //         this.total = new UpgradableNumber(obj.total);
  //       } else {
  //         this.total.base = obj.total;
  //       }
  //     }
  //     if (obj.size) {
  //       if (obj.size.base !== undefined) {
  //         this.size = new UpgradableNumber(obj.size);
  //       } else {
  //         this.size.base = obj.size;
  //       }
  //     } else {
  //       this.size.base = 1;
  //     }
  //     this.stacks = obj.stacks ? obj.stacks : false;
      
  //     this.slots = obj.slots ? obj.slots : false;
  //     this.slot_level = obj.slot_level ? obj.slot_level : 1;
  //     this.slot_name = obj.slot_name ? obj.slot_name : "";
  //     this.refresh_rule = obj.refresh_rule ? obj.refresh_rule : "Inherit";
  //     this.refresh_x_on_short = obj.refresh_x_on_short ? new UpgradableNumber(obj.refresh_x_on_short) : new UpgradableNumber(-1);
  //     this.override_name = obj.override_name ? obj.override_name : "";
  //     this.override_singular = obj.override_singular ? obj.override_singular : "";
  //   }
  // }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      type_id: this.type_id,
      slots: this.slots,
      slot_level: this.slot_level,
      slot_name: this.slot_name,
      total: this.total.toDBObj(),
      size: this.size.toDBObj(),
      stacks: this.stacks,
      refresh_rule: this.refresh_rule,
      refresh_x_on_short: this.refresh_x_on_short.toDBObj(),
      override_name: this.override_name,
      override_singular: this.override_singular
    };
  }

  copy(copyMe: FloatingFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof ResourceFeature) {
      this.safe_copy(copyMe);
    }
  }

  safe_copy(copyMe: ResourceFeature) {
    this.type_id = copyMe.type_id;
    this.slots = copyMe.slots;
    this.slot_level = copyMe.slot_level;
    this.slot_name = copyMe.slot_name;
    this.total = copyMe.total.clone();
    this.size = copyMe.size.clone();
    this.stacks = copyMe.stacks;
    this.resource = copyMe.resource;
    this.refresh_rule = copyMe.refresh_rule;
    this.refresh_x_on_short = copyMe.refresh_x_on_short.clone();
    this.override_name = copyMe.override_name;
    this.override_singular = copyMe.override_singular;
  }

  clone(drop_ids = false): ResourceFeature {
    const new_obj = new ResourceFeature();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}
